<template>
  <div class="locationpicker-container">
     <van-popup v-model="visible" position="bottom">
      <van-picker
        title="选择省份"
        ref="picker"
        :columns="columns"
        :default-index="defaultIndex"
        @confirm="onConfirm"
        @cancel="visible = false"
        show-toolbar
      />
    </van-popup>
  </div>
</template>
<script>
import area from './config/area.json'

export default {
  name: 'provincePicker',
  components: {
  },
  props: {
    defaultIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      columns: Object.keys(area),
      visible: false
    }
  },
  methods: {
    onConfirm(provinceName) {
      const province_id = area[provinceName].val
      this.$emit('setLocation', {
        id: province_id,
        name: provinceName
      })
      this.visible = false
    },
    onCancel() {
      this.visible = false
    }
  }
}
</script>
<style lang="less" scoped>
.locationpicker-container {
  position: absolute;
}
</style>
